// store/useCurrentUser.ts
import { create } from "zustand";
import { devtools, persist, createJSONStorage } from "zustand/middleware";
import type { User } from "@/types/user";

export type AuthState = {
  user: Partial<User> | null;
  token: string | null;
  assetToken: string | null;
  setUser: (user: Partial<User>) => void;
  setToken: (token: string) => void;
  setAssetToken: (assetToken: string) => void;
  removeUser: () => void;
  isAuthenticated: () => boolean;
};

const useCurrentUser = create<AuthState>()(
  devtools(
    persist(
      (set, get) => ({
        token: null,
        user: null,
        assetToken: null,

        setToken: (token) => set({ token }),
        setUser: (user) => set({ user }),
        setAssetToken: (assetToken) => set({ assetToken }),
        removeUser: () => set({ user: null, token: null, assetToken: null }),
        isAuthenticated: () => !!get().token && !!get().user,
      }),
      {
        name: "current-user-storage",
        storage: createJSONStorage(() => localStorage),
      }
    )
  )
);

export default useCurrentUser;
